export default {
  driver_performance_cases_filters_timeFrame: "Timeframe",
  driver_performance_cases_filters_coach: "Coach",
  driver_performance_cases_filters_status: "Status",
  driver_performance_cases_filters_drivers: "Drivers",
  driver_performance_cases_filters_tags: "Tags",
  driver_performance_cases_filters_pending: "Pending",
  driver_performance_cases_filters_evaluate: "Evaluate",
  driver_performance_cases_filters_completed: "Completed",
  driver_performance_cases_filters_expired: "Expired",
};
